function mediaCheck(query) {
    if (window.matchMedia) {
        let mq = window.matchMedia('(' + query + ')');
        return mq.matches;
    } else {
        return false;
    }
}

export default mediaCheck;
